/**
 * Copyright (c) 2017 The xterm.js authors. All rights reserved.
 * @license MIT
 */

export interface ISelectionRedrawRequestEvent {
  start: [number, number] | undefined;
  end: [number, number] | undefined;
  columnSelectMode: boolean;
}

export interface ISelectionRequestScrollLinesEvent {
  amount: number;
  suppressScrollEvent: boolean;
}
